// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-letter-modal__form{position:relative;padding:50px 30px 25px 25px}@media (max-width:767px){.news-letter-modal__form{padding:50px 10px 15px}}.modal-wrapper__overlay.news-letter-modal{z-index:99999}", ""]);
// Exports
module.exports = exports;
